// Queries for the Franchises module
import { gql } from 'apollo-boost';

export const GET_FRANCHISE_PORTFOLIO_OVERVIEW = gql`
query franchisePortfolioOverview {
    franchisePortfolioOverview {
        totalFranchises
        totalSchools
        totalPupilLicences
        totalActivePupils
        totalFranchiseAdmins
        franchises {
            id
            name
            countryCode
            currency
            status
            qualifyingSchoolsCount
            totalSchoolsCount
            totalTeachers
            totalParents
            totalPupilLicences
            leadUserName
        }
        recentActivities {
            id
            metaFormatted
            schoolName
            actionType
            description
        }   
    }
}
`;

export const GET_FRANCHISES = gql`
query franchises {
    franchises {
        id
 
    }
}
`;

export const GET_FRANCHISE_DETAILS = gql`
query franchiseDetails($franchiseId: ID!) {
    franchise(franchiseId: $franchiseId) {
        id
        name
        countryCode
    }
}
`;

export const GET_FRANCHISE_ADMINS = gql`
query franchiseAdmins($franchiseId: ID!) {
    franchise(franchiseId: $franchiseId) {
        id
        name
        memberships {
            id
            userName
            statusLabel
            activityLabel
        }
    }
}
`;

export const INVITE_FRANCHISE_ADMIN = gql`
mutation inviteFranchiseAdmin($franchiseId: ID!, $email: String!, $name: String) {
    inviteFranchiseAdmin(franchiseId: $franchiseId, email: $email, name: $name) {
        membership { id }
        errors
    }
}
`;

export const GET_FRANCHISE = gql`
query franchise($franchiseId: ID, $code: String) {
    franchise(franchiseId: $franchiseId, code: $code) {
        id
        name
        code
        countryCode
        currency
        status
        qualifyingSchoolsCount
        totalSchoolsCount
        totalPupilLicences
        totalTeachers
        totalParents
        leadUserName
        schoolsCountByStatus {
            active
            needsAdmin
            draft
        } 
        memberships {
            id
            userName   
            statusLabel 
            activityLabel 
            
        }
        recentSchools {
            id
            name
            startDate
            pupilsCount
            onboardingStatus
            onboardingStatusLabel
        }
    }
}
`;

export const GET_FRANCHISE_ATTENTION_SCHOOLS = gql`
query franchiseAttentionSchools($franchiseId: ID!, $page: Int!) {
    franchiseSchools(franchiseId: $franchiseId, status: "in_setup", page: $page, perPage: 100) {
        totalPages
        schools {
            id
            primaryAdministrator { id }
            annualPupilLicences
        }
    }
}
`;

export const GET_FRANCHISE_REVENUE_TIER = gql`
query franchiseRevenueTier($franchiseId: ID!) {
    franchise(franchiseId: $franchiseId) {
        id
        name
        revenueTier {
            level
            percentage
            lifetimeSchools
            remainingToNext
            nextTierPercentage
            progressPercentage
        }
        commissionLadder {
            id: level
            level
            percentage
            range
            status
            remainingToNext
        }
        recentQualifyingSchools(limit: 5) {
            id
            name
            qualifyingDateFormatted
        }
    }
}
`;

export const GET_RECENT_FRANCHISE_ACTIVITIES = gql`
query recentFranchiseActivities {
    recentFranchiseActivities {
        id
    }
}
`;

export const GET_FRANCHISE_SCHOOLS = gql`
query franchiseSchools($franchiseId: ID, $code: String, $search: String, $status: String, $page: Int, $perPage: Int) {
    franchiseSchools(franchiseId: $franchiseId, code: $code, search: $search, status: $status, page: $page, perPage: $perPage) {
        territoryLabel
        franchise {
            id
            name
        }
        totalCount
        filteredCount
        activeCount
        inSetupCount
        needsAdminCount
        noAdminCount
        schools {
            id
            name
            schoolCode
            pupilsCount
            startDate
            onboardingStatus
            onboardingStatusLabel
            primaryAdministratorName
        }
        page
        perPage
        totalPages
        pageNumbers
        showingFrom
        showingTo
        showingLabel
        hasNextPage
        hasPreviousPage
    }
}
`;

export const GET_FRANCHISE_SCHOOL = gql`
query franchiseSchool($schoolId: ID!) {
    school(schoolId: $schoolId) {
        id
        name
        schoolCode
        franchise {
            id
            name
        }
        onboardingStatusLabel
        annualPupilLicences
        assignedPupilLicences
        assignedPupilLicencesLabel
        assignedPupilLicencesPercentage
        pupilLicencesAssignedLabel
        totalTeachersCount
        activeTeachersCount
        activeTeachersLabel
        totalParentsCount
        activeParentsCount
        activeParentsLabel
        academicYearReadingLogsCount
        fullAddress
        contactLabel
        schoolPhoneNumber
        createdDateFormatted
        primaryAdministratorName
        primaryAdministratorEmail
        primaryAdministratorInitials
        primaryAdministratorStatusLabel
        primaryAdministratorLastActiveFormatted
        licencePeriodFormatted
        franchiseActivities {
            id
            description
            metaFormatted
        }
    }
}
`;

export const CREATE_FRANCHISE = gql`
mutation createFranchise($name: String!, $code: String!, $countryCode: String, $currency: String, $leadUserName: String, $leadUserEmail: String) {
    createFranchise(name: $name, code: $code, countryCode: $countryCode, currency: $currency, leadUserName: $leadUserName, leadUserEmail: $leadUserEmail) {
        franchise {
            id
            name
            code
            countryCode
            currency
            status
            leadUserName
        }
        errors
    }
}
`;

export const CREATE_FRANCHISE_SCHOOL = gql`
mutation createFranchiseSchool($franchiseId: ID, $name: String!, 
$schoolCode: String, $address: String, $address2: String, $city: String, 
$postcode: String, $country: String, $contactName: String, $contactEmail: String, 
$schoolPhoneNumber: String, $schoolType: String, $curriculumId: Int, $adminFirstName: String, $adminLastName: String,
$adminEmail: String, $adminRole: String, $sendAdminInvitation: Boolean, $pupilLicences: Int, $licenceStartDate: ISO8601Date, $licenceEndDate: ISO8601Date,
$telephone: String, $onboardingStatus: String) {
    createFranchiseSchool(franchiseId: $franchiseId ,name: $name, 
    schoolCode: $schoolCode, address: $address, address2: $address2, city: $city, 
    postcode: $postcode, country: $country, contactName: $contactName, contactEmail: $contactEmail, 
    schoolPhoneNumber: $schoolPhoneNumber, schoolType: $schoolType, curriculumId: $curriculumId, adminFirstName: $adminFirstName,
    adminLastName: $adminLastName, adminEmail: $adminEmail, adminRole: $adminRole, sendAdminInvitation: $sendAdminInvitation,
    pupilLicences: $pupilLicences, licenceStartDate: $licenceStartDate, licenceEndDate: $licenceEndDate, telephone: $telephone,
    onboardingStatus: $onboardingStatus) {
        school {
            id
            name
            schoolCode
            pupilsCount
            startDate
            onboardingStatusLabel
        }
        errors
    }
}
`;

export const GET_FRANCHISE_SCHOOL_FOR_EDIT = gql`
query franchiseSchoolForEdit($schoolId: ID!) {
    school(schoolId: $schoolId) {
        id
        name
        onboardingStatus
        schoolCode
        address
        city
        contactName
        contactEmail
        annualPupilLicences
        assignedPupilLicences
        licencePeriodStart
        licencePeriodEnd
        franchise {
            id
            name
        }
    }
}
`;

export const EDIT_FRANCHISE_SCHOOL = gql`
mutation updateFranchiseSchool(
    $schoolId: ID!
    $name: String
    $address: String
    $address2: String
    $city: String
    $governorate: String
    $zip: String
    $postcode: String
    $country: String
    $contactName: String
    $contactEmail: String
    $schoolType: String
    $curriculumId: Int
    $telephone: String
    $schoolPhoneNumber: String
    $annualPupilLicences: Int
    $pupilLicences: Int
    $licenceStartDate: ISO8601Date
    $licenceEndDate: ISO8601Date
    $startDate: ISO8601Date
    $endDate: ISO8601Date
    $status: String
    $onboardingStatus: String
    $sendAdminInvitation: Boolean
) {
    updateFranchiseSchool(
        schoolId: $schoolId
        name: $name
        address: $address
        address2: $address2
        city: $city
        governorate: $governorate
        zip: $zip
        postcode: $postcode
        country: $country
        contactName: $contactName
        contactEmail: $contactEmail
        schoolType: $schoolType
        curriculumId: $curriculumId
        telephone: $telephone
        schoolPhoneNumber: $schoolPhoneNumber
        annualPupilLicences: $annualPupilLicences
        pupilLicences: $pupilLicences
        licenceStartDate: $licenceStartDate
        licenceEndDate: $licenceEndDate
        startDate: $startDate
        endDate: $endDate
        status: $status
        onboardingStatus: $onboardingStatus
        sendAdminInvitation: $sendAdminInvitation
    ) {
        school {
            id
            name
            schoolCode
            pupilsCount
            startDate
            onboardingStatusLabel
        }
        errors
    }
}
`;

export const DEACTIVATE_FRANCHISE_SCHOOL = gql`
mutation deactivateFranchiseSchool($schoolId: ID!) {
    deactivateFranchiseSchool(schoolId: $schoolId) {
        school {
            id
            name
            schoolCode
            pupilsCount
            startDate
            onboardingStatusLabel
        }
        errors
    }
}
`;

export const GET_FRANCHISE_SCHOOL_ADMINS = gql`
query franchiseSchoolAdmins($schoolId: ID!) {
    school(schoolId: $schoolId) {
        id
        name
        franchise { id name }
        administratorAccountsCount
        administratorAccountsSummary
        primaryAdministrator { id }
        admins {
            id
            firstName
            lastName
            email
            initials
            roleTitle(schoolId: $schoolId)
            status(schoolId: $schoolId)
            statusLabel(schoolId: $schoolId)
            activityLabel(schoolId: $schoolId)
        }
    }
}
`;

export const INVITE_SCHOOL_ADMINISTRATOR = gql`
mutation inviteSchoolAdministrator($schoolId: ID!, $name: String, $email: String!, $sendAdminInvitation: Boolean) {
    inviteSchoolAdministrator(schoolId: $schoolId, name: $name, email: $email, sendAdminInvitation: $sendAdminInvitation) {
        admin { id }
        errors
    }
}
`;

export const GET_FRANCHISE_SCHOOL_ADMINISTRATORS = gql`
query franchiseSchoolAdministrators($franchiseId: ID, $search: String, $page: Int, $perPage: Int) {
    franchiseSchoolAdministrators(franchiseId: $franchiseId, search: $search, page: $page, perPage: $perPage) {
        totalAdminsCount
        activeAdminsCount
        pendingInvitesCount
        schoolsWithoutAdminCount
        totalCount
        currentPage
        perPage
        totalPages
        administrators {
            teacherId
            schoolId
            name
            email
            schoolName
            status
            statusLabel
            lastActiveFormatted
        }
    }
}
`;

export const GET_FRANCHISE_INVITE_SCHOOLS = gql`
query franchiseInviteSchools($franchiseId: ID!, $page: Int, $perPage: Int) {
    franchiseSchools(franchiseId: $franchiseId, page: $page, perPage: $perPage) {
        schools { id name }
        totalPages
    }
}
`;


export const GET_FRANCHISE_REVENUE_AND_INVOICING = gql`
query franchiseRevenueAndInvoicing($franchiseId: ID, $code: String) {
    franchiseRevenueAndInvoicing(franchiseId: $franchiseId, code: $code) {
        franchise {
            id
            name
            code
        }
        currency
        periodStart
        periodEnd
        periodLabel
        invoiceWindow
        qualifyingPaidLicences
        grossFeePool
        grossFeePoolFormatted
        partnerCommissionPercentage
        partnerShareAmount
        partnerShareAmountFormatted
        boomShareAmount
        boomShareAmountFormatted
        invoiceStatus
        uninvoicedSchoolsCount
        currentInvoice {
            ...FranchiseRevenueInvoiceFields
        }
        commissionLadder {
            id: level
            level
            percentage
            range
            remainingToNext
            nextBandThreshold
            subtitle
            status
        }
        progressPercentage
        progressCaption
        currentBandSchoolsCount
        currentBandThreshold
        invoiceHistory {
            ...FranchiseRevenueInvoiceFields
        }
    }
}

fragment FranchiseRevenueInvoiceFields on FranchiseInvoice {
    id
    invoiceNumber
    periodStart
    periodEnd
    periodLabel
    issuedAt
    issuedDateFormatted
    qualifyingLicencesCount
    grossAmount
    grossAmountFormatted
    grossAmountCurrency
    commissionPercentage
    franchiseShareAmount
    franchiseShareAmountFormatted
    boomShareAmount
    boomShareAmountFormatted
    status
}
`;

export const GENERATE_FRANCHISE_INVOICE = gql`
mutation generateFranchiseInvoice($franchiseId: ID!) {
    generateFranchiseInvoice(franchiseId: $franchiseId) {
        invoice {
            id
            invoiceNumber
        }
        errors
    }
}
`;
